import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { newNoPlaceZoneBooking } from "../../../utils/axios-requests";
import {
  buildConferenceVisitorRegistrationDtos,
  conferenceRoomLocationFromInputs
} from "../functions/team-visitor-invitation.functions";
import { BookingStrategyContext } from "./bookingStrategies";
import { buildUsers } from "./buildUsers.function";
import { runBookingWriteWithCancelConfirm } from "./runBookingWriteWithCancelConfirm.function";

export const conferenceZoneStandardStrategy = (ctx: BookingStrategyContext) => {
  const users = buildUsers(ctx);
  const conferenceZoneVisitorRegistrations = buildConferenceVisitorRegistrationDtos(
    ctx.inputs.visitorRegistrations,
    conferenceRoomLocationFromInputs(ctx.inputs)
  );

  const basePayload = {
    users,
    weekdays: ctx.weekdayInput(ctx.inputs),
    subject: ctx.inputs.subject,
    bookingType: ctx.inputs.bookingType as BookingType,
    description: ctx.inputs.description,
    locationInventoryId: ctx.inputs.selectedLocation,
    conferenceZoneBookingGuests: ctx.inputs.zoneAccess || [],
    conferenceZoneVisitorRegistrations,
    onlineMeetingProvider: ctx.inputs.onlineMeetingProvider || null,
    bookingServicesDto: ctx.handleToBookingServiceDto(
      users[0].bookingInventoryId,
      ctx.inputs.conferenceService
    ),
    ...ctx.standardBookingInfo,
    ...ctx.standardBookingTimes
  };

  runBookingWriteWithCancelConfirm(
    confirmCancelExistingBookings =>
      newNoPlaceZoneBooking({
        ...basePayload,
        ...(confirmCancelExistingBookings ? { confirmCancelExistingBookings: true } : {})
      }),
    {
      onSuccess: ctx.onSuccess,
      onError: ctx.onError,
      onCancelExistingConfirmationRequired: ctx.onCancelExistingConfirmationRequired
    }
  );
};
